export default __webpack_public_path__ + "media/spotify.01076641.svg";